// Browser detection utility
export const detectBrowser = () => {
    const userAgent = navigator.userAgent;
    const browserInfo = {
        name: '',
        version: '',
        isOutdated: false,
        isSupported: true
    };

    // Chrome detection
    if (userAgent.includes('Chrome') && !userAgent.includes('Edg') && !userAgent.includes('OPR')) {
        browserInfo.name = 'Chrome';
        const match = userAgent.match(/Chrome\/(\d+)/);
        if (match) {
            browserInfo.version = parseInt(match[1]);
            browserInfo.isOutdated = browserInfo.version < 137; // Chrome 137+ is supported (latest 2 versions)
        }
    }
    // Firefox detection
    else if (userAgent.includes('Firefox')) {
        browserInfo.name = 'Firefox';
        const match = userAgent.match(/Firefox\/(\d+)/);
        if (match) {
            browserInfo.version = parseInt(match[1]);
            browserInfo.isOutdated = browserInfo.version < 139; // Firefox 139+ is supported (latest 2 versions)
        }
    }
    // Safari detection
    else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
        browserInfo.name = 'Safari';
        const match = userAgent.match(/Version\/(\d+)/);
        if (match) {
            browserInfo.version = parseInt(match[1]);
            browserInfo.isOutdated = browserInfo.version < 16; // Safari 16+ is supported (latest 2 versions)
        }
    }
    // Edge detection
    else if (userAgent.includes('Edg')) {
        browserInfo.name = 'Edge';
        const match = userAgent.match(/Edg\/(\d+)/);
        if (match) {
            browserInfo.version = parseInt(match[1]);
            browserInfo.isOutdated = browserInfo.version < 137; // Edge 137+ is supported (latest 2 versions)
        }
    }
    // Internet Explorer detection
    else if (userAgent.includes('MSIE') || userAgent.includes('Trident')) {
        browserInfo.name = 'Internet Explorer';
        browserInfo.isOutdated = true;
        browserInfo.isSupported = false;
    }
    // Unknown browser
    else {
        browserInfo.name = 'Unknown';
        browserInfo.isOutdated = true;
        browserInfo.isSupported = false;
    }

    return browserInfo;
};

export const getBrowserWarningMessage = (browserInfo) => {
    if (!browserInfo.isSupported) {
        return {
            title: 'Unsupported Browser',
            message: `Your browser (${browserInfo.name}) is not supported. Please use a modern browser like Chrome, Firefox, Safari, or Edge.`,
            severity: 'error'
        };
    }
    
    if (browserInfo.isOutdated) {
        return {
            title: 'Outdated Browser',
            message: `Your ${browserInfo.name} browser (version ${browserInfo.version}) is outdated. For the best experience, please update to the latest version.`,
            severity: 'warning'
        };
    }
    
    return null;
};
